import { render } from "./HighlightBadgeNodeView.vue?vue&type=template&id=e8248e56"
import script from "./HighlightBadgeNodeView.vue?vue&type=script&lang=js"
export * from "./HighlightBadgeNodeView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__